<template>
  <v-dialog persistent v-model="dialog" max-width="500px">

    <v-btn slot="activator" flat icon class="mb-2">
      <v-icon>add_circle_outline</v-icon>
    </v-btn>

    <v-card ref="form">
      <v-card-text>
        <v-text-field
          ref="name"
          v-model="name"
          :rules="[() => !!name || 'This field is required']"
          :error-messages="errorMessages"
          label="Full Name"
          placeholder="John Doe"
          required
        ></v-text-field>

        <v-text-field
          ref="loc"
          :rules="[
              () => !!loc || 'This field is required',
              () => !!loc && loc.length <= 2 || 'Location code must be 2 characters']"
          v-model="loc"
          label="Location (2 Letter State Code)"
          placeholder="AL"
          counter="2"
          required
        ></v-text-field>

        <v-text-field
          ref="crewid"
          :rules="[() => !!crewid || 'This field is required']"
          v-model="crewid"
          label="Crew ID"
          placeholder="1337"
          required
        ></v-text-field>
      </v-card-text>

      <v-divider class="mt-5"></v-divider>

      <v-card-actions>
        <v-btn flat @click.native="dialog = false">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-slide-x-reverse-transition>
          <v-tooltip
            v-if="formHasErrors"
            left
          >
            <v-btn
              slot="activator"
              icon
              class="my-0"
              @click="resetForm"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh form</span>
          </v-tooltip>
        </v-slide-x-reverse-transition>
        <v-btn flat @click="submit">Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      errorMessages: [],
      name: null,
      loc: null,
      crewid: null,
      formHasErrors: false
    }),

    computed: {
      form() {
        return {
          name: this.name,
          loc: this.loc,
          crewid: this.crewid
        }
      }
    },

    watch: {
      name() {
        this.errorMessages = []
      }
    },

    methods: {
      resetForm() {
        this.errorMessages = []
        this.formHasErrors = false

        Object.keys(this.form).forEach(f => {
          this.$refs[f].reset()
        })
      },
      submit() {
        this.formHasErrors = false

        Object.keys(this.form).forEach(f => {
          if (!this.form[f]) this.formHasErrors = true

          this.$refs[f].validate(true)
        })

        if (this.formHasErrors) {
          return;
        }

        var screenerObject = {
          name: this.name,
          hnotes: '',
          loc: this.loc,
          crewid: this.crewid
        }

        this.$http.post('/panel/screener', screenerObject, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(response => {
            if (response.data.success) {
              this.resetForm();
              this.$emit('update')
              this.dialog = false;
            } else {
              this.$root.$emit('snackbar', response.data.msg)
            }
          })
          .catch(e => {
            // console.log(JSON.stringify(e));
            this.$root.$emit('snackbar', e.response.data.msg)
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dialogs/ScreenerDialog.vue